import React from "react";
import "./deleteUser.css";

interface UserData {
  id: number;
  userId: string;
  role: string;
}

interface DeleteUserProps {
  isOpen: boolean;
  onClose: () => void;
  userData: UserData | null;
  onConfirmDelete: (userId: number) => void;
}

const DeleteUser: React.FC<DeleteUserProps> = ({
  isOpen,
  onClose,
  userData,
  onConfirmDelete,
}) => {
  const handleDelete = () => {
    if (userData) {
      onConfirmDelete(userData.id);
    }
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  if (!isOpen || !userData) return null;

  return (
    <div className="delete-user-overlay" onClick={onClose}>
      <div className="delete-user-wrapper">
        <button className="delete-user-close" onClick={onClose}>
          ×
        </button>
        <div className="delete-user-modal" onClick={(e) => e.stopPropagation()}>
          <div className="delete-user-content">
            <h2 className="delete-user-title">User Management</h2>
            <p className="delete-user-description">Add, Edit or Delete users</p>

            <div className="delete-user-form-box">
              <h3 className="delete-user-form-title">Delete User</h3>

              <p className="delete-user-confirmation">
                Are you sure you want to delete username "{userData.userId}"
                permanently?
              </p>
            </div>

            <div className="delete-user-actions">
              <button className="delete-user-cancel-btn" onClick={handleCancel}>
                ← Cancel
              </button>
              <button className="delete-user-delete-btn" onClick={handleDelete}>
                Delete User →
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteUser;
